<section [class.no-parameters]="!args"
         [class.mat-typography]="!args">
    <ng-container *ngIf="args; else noParameters">
        <mat-tab-group>
            <div class="parameter-collection-container">
                <mat-tab #inputTab
                         aria-label="input-arguments">
                    <ng-template mat-tab-label>
                        <mat-icon *ngIf="isOpen"
                                  class="mat-accent">edit</mat-icon>
                        <mat-icon svgIcon="uipath:inputParameter"></mat-icon>
                        {{ 'parameter_collection_process_type_input' | translate }}
                    </ng-template>
                </mat-tab>
                <mat-tab #outputTab
                         aria-label="output-arguments">
                    <ng-template mat-tab-label>
                        <mat-icon svgIcon="uipath:outputParameter"></mat-icon>
                        {{ 'parameter_collection_process_type_output' | translate }}
                    </ng-template>
                </mat-tab>
            </div>
        </mat-tab-group>
        <ui-parameter-collection #inputParameterCollection
                                 [hidden]="!inputTab.isActive"
                                 [ngModel]="value"
                                 [collection]="args.input"
                                 [editable]="editable"
                                 (ngModelChange)="onModelChange($event)"
                                 (closed)="onTouch()"
                                 type="input">
        </ui-parameter-collection>
        <ui-parameter-collection [hidden]="!outputTab.isActive"
                                 [collection]="args.output"
                                 type="output">
        </ui-parameter-collection>
    </ng-container>
    <ng-template #noParameters>
        <h4 translate="process_modal_no_parameter_info"></h4>
    </ng-template>
</section>
